import * as util from '@/util';
import { EditorAPIKey } from '@/apis';
import type { Shell } from '@/apilib';

const { applyForFirstAndThrowIfMulti } = util.array;

export function createMediaApi(shell: Shell) {
  const editorAPI = shell.getAPI(EditorAPIKey);
  function getSvgOriginalAspectRatio(compRefs: AnyFixMe) {
    return applyForFirstAndThrowIfMulti(
      'getSvgOriginalAspectRatio',
      editorAPI.dsRead.media.vectorImage.getSvgOriginalAspectRatio,
      compRefs,
    );
  }

  return {
    vectorImage: {
      getSvgOriginalAspectRatio,
    },
  };
}
